import React from "react";
import { COLLECTORS } from "../data/site";

export default function Testimonials({ limit = 2, eyebrow = "From collectors", className = "" }) {
  const items = COLLECTORS.testimonials.slice(0, limit);
  return (
    <section className={`border-t border-border ${className}`} data-testid="testimonials">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <p className="label mb-8">{eyebrow}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          {items.map((t) => (
            <blockquote key={t.attribution} className="border-l-2 border-[hsl(var(--accent))] pl-6">
              <p className="serif italic text-xl md:text-2xl leading-snug">“{t.quote}”</p>
              <footer className="mt-3 label text-[hsl(var(--ink-soft))]">{t.attribution}</footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
